import { api } from "./api";
import type { ExportJob } from "../types/api";

/** Authenticated download of a ready export job (sends the JWT, saves the file). */
export async function downloadExport(job: ExportJob): Promise<void> {
  if (job.status !== "ready") return;
  const res = await api.get(`/exports/${job.id}/download/`, { responseType: "blob" });
  const blob = new Blob([res.data]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${job.title.replace(/\s+/g, "_")}.${job.fmt}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
